import type { JSX } from 'react';
import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { calculateLdlHdlRatioString } from '@common/utils/ldlHdl';

type LdlHdlRatioProps = Readonly<{
    hdlCholesterol: number | null;
    ldlCholesterol: number | null;
}>;

export function LdlHdlRatio(props: LdlHdlRatioProps): JSX.Element | null {
    const { hdlCholesterol, ldlCholesterol } = props;

    if (hdlCholesterol === null || hdlCholesterol <= 0 || ldlCholesterol === null || ldlCholesterol <= 0) {
        return null;
    }

    return (
        <FormGroup label="LDL/HDL ratio">
            <FormParagraph>{calculateLdlHdlRatioString(ldlCholesterol, hdlCholesterol)}</FormParagraph>
        </FormGroup>
    );
}
